import { ActionContext } from 'vuex'
import apiFlux from '@/api/flux'
import apiDataSource from '@/api/datasource'
import apiPartenaire from '@/api/partenaire'
import apiFeedDownload from '@/api/feedDownload'
import apiPersonne from '@/api/personne'
import apiProfilExclusion from '@/api/profilExclusion'
import apiGroupCarac from '@/api/groupCarac'
import apiCarac from '@/api/carac'

import apiFacetteType from '@/api/facetteType'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure, payloadAction } from '@/store'
import { IAdministrationState } from './state'
import { buildStateItem } from '@/models/alo/StateItem'
import { AloPartenaire } from '@/models/alo/AloPartenaire'
import { AloFlux } from '@/models/alo/AloFlux'
import { AloDataSource } from '@/models/alo/AloDataSource'
import { AloMeta } from '@/models/alo/AloMeta'
import { AloFeedDownload } from '@/models/alo/AloFeedDownload'
import { AloPersonne } from '@/models/alo/AloPersonne'
import { AloFacetteType } from '@/models/alo/AloFacetteType'
import { AloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import { AloGroupCarac } from '@/models/alo/AloGroupCarac'

export class AdministrationAction {
    public [types.ADM_PARTENAIRE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_PARTENAIRE_REQUEST,types.ADM_PARTENAIRE_SUCCESS,types.ADM_PARTENAIRE_ERROR,apiPartenaire.getAllPartenaires)    
    }

    public [types.ADM_PARTENAIRE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_PARTENAIRE_REQUEST,context.state.partenaireList)    
    }

    public [types.ADM_PARTENAIRE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_PARTENAIRE_DETAIL_REQUEST,types.ADM_PARTENAIRE_DETAIL_SUCCESS,types.ADM_PARTENAIRE_DETAIL_ERROR,apiPartenaire.getPartenaire,id)
    }

    public [types.ADM_PARTENAIRE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.partenaire[id];
        return actionEnsure(context,types.ADM_PARTENAIRE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_PARTENAIRE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloPartenaire) {
        return payloadAction(context,types.ADM_PARTENAIRE_SAVE_REQUEST,types.ADM_PARTENAIRE_SAVE_SUCCESS,types.ADM_PARTENAIRE_SAVE_ERROR,apiPartenaire.savePartenaire,data)    
    }
    public [types.ADM_PARTENAIRE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_PARTENAIRE_DELETE_REQUEST,types.ADM_PARTENAIRE_DELETE_SUCCESS,types.ADM_PARTENAIRE_DELETE_ERROR,apiPartenaire.deletePartenaire,id)    
    }
    public [types.ADM_PARTENAIRE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise<void>((resolve, reject) => {
            context.commit(types.ADM_PARTENAIRE_RESET_STATUS)
            resolve()
        })
    }
    
    public [types.ADM_FLUX_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_FLUX_REQUEST,types.ADM_FLUX_SUCCESS,types.ADM_FLUX_ERROR,apiFlux.getAllFlux)    
    }

    public [types.ADM_FLUX_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_FLUX_REQUEST,context.state.fluxList)    
    }

    public [types.ADM_FLUX_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_FLUX_DETAIL_REQUEST,types.ADM_FLUX_DETAIL_SUCCESS,types.ADM_FLUX_DETAIL_ERROR,apiFlux.getFlux,id)
    }

    public [types.ADM_FLUX_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.flux[id];
        return actionEnsure(context,types.ADM_FLUX_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }
    public [types.ADM_FLUX_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloFlux) {
        return payloadAction(context,types.ADM_FLUX_SAVE_REQUEST,types.ADM_FLUX_SAVE_SUCCESS,types.ADM_FLUX_SAVE_ERROR,apiFlux.saveFlux,data)    
    }
    public [types.ADM_FLUX_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_FLUX_DELETE_REQUEST,types.ADM_FLUX_DELETE_SUCCESS,types.ADM_FLUX_DELETE_ERROR,apiFlux.deleteFlux,id)    
    }
    public [types.ADM_FLUX_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise<void>((resolve, reject) => {
            context.commit(types.ADM_FLUX_RESET_STATUS)
            resolve()
        })
    }

    public [types.ADM_DATASOURCE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_DATASOURCE_REQUEST,types.ADM_DATASOURCE_SUCCESS,types.ADM_DATASOURCE_ERROR,apiDataSource.getAllDataSource)    
    }

    public [types.ADM_DATASOURCE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_DATASOURCE_REQUEST,context.state.dataSourcesList)    
    }

    public [types.ADM_DATASOURCE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_DATASOURCE_DETAIL_REQUEST,types.ADM_DATASOURCE_DETAIL_SUCCESS,types.ADM_DATASOURCE_DETAIL_ERROR,apiDataSource.getDataSource,id)
    }

    public [types.ADM_DATASOURCE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.dataSources[id];
        return actionEnsure(context,types.ADM_DATASOURCE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }
    public [types.ADM_DATASOURCE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloDataSource) {
        return payloadAction(context,types.ADM_DATASOURCE_SAVE_REQUEST,types.ADM_DATASOURCE_SAVE_SUCCESS,types.ADM_DATASOURCE_SAVE_ERROR,apiDataSource.saveDataSource,data)    
    }
    public [types.ADM_DATASOURCE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise<void>((resolve, reject) => {
            context.commit(types.ADM_DATASOURCE_RESET_STATUS)
            resolve()
        })
    }
    public [types.ADM_DATASOURCE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_DATASOURCE_DELETE_REQUEST,types.ADM_DATASOURCE_DELETE_SUCCESS,types.ADM_DATASOURCE_DELETE_ERROR,apiDataSource.deleteDataSource,id)    
    }

    public [types.ADM_FEEDDOWNLOAD_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_FEEDDOWNLOAD_REQUEST,types.ADM_FEEDDOWNLOAD_SUCCESS,types.ADM_FEEDDOWNLOAD_ERROR,apiFeedDownload.getAllFeedDownload)    
    }

    public [types.ADM_FEEDDOWNLOAD_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_FEEDDOWNLOAD_REQUEST,context.state.feedDownloadsList)    
    }

    public [types.ADM_FEEDDOWNLOAD_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_FEEDDOWNLOAD_DETAIL_REQUEST,types.ADM_FEEDDOWNLOAD_DETAIL_SUCCESS,types.ADM_FEEDDOWNLOAD_DETAIL_ERROR,apiFeedDownload.getFeedDownload,id)
    }

    public [types.ADM_FEEDDOWNLOAD_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.feedDownloads[id];
        return actionEnsure(context,types.ADM_FEEDDOWNLOAD_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }
    public [types.ADM_FEEDDOWNLOAD_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloFeedDownload) {
        return payloadAction(context,types.ADM_FEEDDOWNLOAD_SAVE_REQUEST,types.ADM_FEEDDOWNLOAD_SAVE_SUCCESS,types.ADM_FEEDDOWNLOAD_SAVE_ERROR,apiFeedDownload.saveFeedDownload,data)    
    }
    public [types.ADM_FEEDDOWNLOAD_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise<void>((resolve, reject) => {
            context.commit(types.ADM_FEEDDOWNLOAD_RESET_STATUS)
            resolve()
        })
    }
    public [types.ADM_FEEDDOWNLOAD_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_FEEDDOWNLOAD_DELETE_REQUEST,types.ADM_FEEDDOWNLOAD_DELETE_SUCCESS,types.ADM_FEEDDOWNLOAD_DELETE_ERROR,apiFeedDownload.deleteFeedDownload,id)    
    }

    //////////////////////////////////////////////////////////////////
    // PERSONNE
    /////////////////////////////////////////////////////////////////

    public [types.ADM_PERSONNE_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_PERSONNE_REQUEST,types.ADM_PERSONNE_SUCCESS,types.ADM_PERSONNE_ERROR,apiPersonne.getAllPersonne)    
    }

    public [types.ADM_PERSONNE_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_PERSONNE_REQUEST,context.state.personneList)    
    }

    public [types.ADM_PERSONNE_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_PERSONNE_DETAIL_REQUEST,types.ADM_PERSONNE_DETAIL_SUCCESS,types.ADM_PERSONNE_DETAIL_ERROR,apiPersonne.getPersonne,id)
    }

    public [types.ADM_PERSONNE_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.personneDic[id];
        return actionEnsure(context,types.ADM_PERSONNE_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }

    public [types.ADM_PERSONNE_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloPersonne) {
        return payloadAction(context,types.ADM_PERSONNE_SAVE_REQUEST,types.ADM_PERSONNE_SAVE_SUCCESS,types.ADM_PERSONNE_SAVE_ERROR,apiPersonne.savePersonne,data)    
    }

    public [types.ADM_PERSONNE_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_PERSONNE_DELETE_REQUEST,types.ADM_PERSONNE_DELETE_SUCCESS,types.ADM_PERSONNE_DELETE_ERROR,apiPersonne.deletePersonne,id)    
    }

    public [types.ADM_PERSONNE_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise<void>((resolve, reject) => {
            context.commit(types.ADM_PERSONNE_RESET_STATUS)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // PROFIL_EXCLUSION
    /////////////////////////////////////////////////////////////////
    public [types.ADM_PROFIL_EXCLUSION_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_PROFIL_EXCLUSION_REQUEST,types.ADM_PROFIL_EXCLUSION_SUCCESS,types.ADM_PROFIL_EXCLUSION_ERROR,apiProfilExclusion.getAllProfilExclusion)    
    }

    public [types.ADM_PROFIL_EXCLUSION_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_PROFIL_EXCLUSION_REQUEST,context.state.profilExclusionList)    
    }

    public [types.ADM_PROFIL_EXCLUSION_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_PROFIL_EXCLUSION_DETAIL_REQUEST,types.ADM_PROFIL_EXCLUSION_DETAIL_SUCCESS,types.ADM_PROFIL_EXCLUSION_DETAIL_ERROR,apiProfilExclusion.getProfilExclusion,id)
    }

    public [types.ADM_PROFIL_EXCLUSION_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.profilExclusion[id];
        return actionEnsure(context,types.ADM_PROFIL_EXCLUSION_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }
    public [types.ADM_PROFIL_EXCLUSION_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloProfilExclusion) {
        return payloadAction(context,types.ADM_PROFIL_EXCLUSION_SAVE_REQUEST,types.ADM_PROFIL_EXCLUSION_SAVE_SUCCESS,types.ADM_PROFIL_EXCLUSION_SAVE_ERROR,apiProfilExclusion.saveProfilExclusion,data)    
    }
    public [types.ADM_PROFIL_EXCLUSION_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_PROFIL_EXCLUSION_DELETE_REQUEST,types.ADM_PROFIL_EXCLUSION_DELETE_SUCCESS,types.ADM_PROFIL_EXCLUSION_DELETE_ERROR,apiProfilExclusion.deleteProfilExclusion,id)    
    }
    public [types.ADM_PROFIL_EXCLUSION_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise<void>((resolve, reject) => {
            context.commit(types.ADM_PROFIL_EXCLUSION_RESET_STATUS)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // GROUP_CARAC
    /////////////////////////////////////////////////////////////////
    public [types.ADM_GROUP_CARAC_REQUEST](context: ActionContext<IAdministrationState, IRootState>) {
        return emptyAction(context,types.ADM_GROUP_CARAC_REQUEST,types.ADM_GROUP_CARAC_SUCCESS,types.ADM_GROUP_CARAC_ERROR,apiGroupCarac.getAllGroupCarac)    
    }

    public [types.ADM_GROUP_CARAC_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_GROUP_CARAC_REQUEST,context.state.groupCaracList)    
    }

    public [types.ADM_GROUP_CARAC_DETAIL_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        return payloadAction(context,types.ADM_GROUP_CARAC_DETAIL_REQUEST,types.ADM_GROUP_CARAC_DETAIL_SUCCESS,types.ADM_GROUP_CARAC_DETAIL_ERROR,apiGroupCarac.getGroupCarac,id)
    }

    public [types.ADM_GROUP_CARAC_DETAIL_ENSURE](context: ActionContext<IAdministrationState, IRootState>,id:number) {
        //Hack car le detail n'est pas dans un stateItems
        const item = context.state.groupCarac[id];
        return actionEnsure(context,types.ADM_GROUP_CARAC_DETAIL_REQUEST,buildStateItem(item,item?5:-5),id)
    }
    public [types.ADM_GROUP_CARAC_SAVE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,data: AloGroupCarac) {
        return payloadAction(context,types.ADM_GROUP_CARAC_SAVE_REQUEST,types.ADM_GROUP_CARAC_SAVE_SUCCESS,types.ADM_GROUP_CARAC_SAVE_ERROR,apiGroupCarac.saveGroupCarac,data)    
    }
    public [types.ADM_GROUP_CARAC_DELETE_REQUEST](context: ActionContext<IAdministrationState, IRootState>,id: number) {
        return payloadAction(context,types.ADM_GROUP_CARAC_DELETE_REQUEST,types.ADM_GROUP_CARAC_DELETE_SUCCESS,types.ADM_GROUP_CARAC_DELETE_ERROR,apiGroupCarac.deleteGroupCarac,id)    
    }
    public [types.ADM_GROUP_CARAC_RESET_STATUS](context: ActionContext<IAdministrationState, IRootState>) {
        return new Promise<void>((resolve, reject) => {
            context.commit(types.ADM_GROUP_CARAC_RESET_STATUS)
            resolve()
        })
    }
    public [types.ADM_CARAC_REQUEST](context: ActionContext<IAdministrationState, IRootState>,filter:{u?:number,r?:number,f?:number,s?:string}) {
        return payloadAction(context,types.ADM_CARAC_REQUEST,types.ADM_CARAC_SUCCESS,types.ADM_CARAC_ERROR,apiCarac.getCarac,filter)    
    }
    public [types.ADM_CARAC_ENSURE](context: ActionContext<IAdministrationState, IRootState>) {
        return actionEnsure(context,types.ADM_CARAC_REQUEST,context.state.caracList)    
    }           
}

export default util.classToObject(AdministrationAction)
